const REGION = process.env.VUE_APP_AMPLIFY_REGION;
const USER_POOL_ID = process.env.VUE_APP_AMPLIFY_USER_POOL_ID;
const WEB_CLIENT_ID = process.env.VUE_APP_AMPLIFY_USER_POOL_WEB_CLIENT_ID;

export const AwsConfigAuth = {
  region: REGION,
  userPoolId: USER_POOL_ID,
  userPoolWebClientId: WEB_CLIENT_ID,
};
